import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useOverviewStepSectionStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        fieldLabel: {
            color: theme.palette.grey["600"],
            fontWeight: 600,
            fontSize: theme.typography.pxToRem(12),
            textTransform: "uppercase",
        },
        fieldValue: {
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.primary.dark,
        },
    });
};
